import type { AbilitiesEvaluation } from "vue-simple-acl/types/acl";
import { PATH_UNAUTHORIZED } from "~/core/constants/paths";
import type { ACLRoles } from "~/core/models/ACLRoles.enum";

export async function canWithRedirection(
  can: AbilitiesEvaluation,
  permission: ACLRoles | ACLRoles[],
) {
  const perm = can(permission);
  if (!perm) {
    const router = useRouter();
    await router.push({ path: PATH_UNAUTHORIZED });
  }
  return perm;
}
